import classNames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { withModalContext } from './ModalContext';
import { IModalBody } from './types';
import { classAttr } from './utils';

/**
 * Wrapper for the main part of a Modal to maintain appropriate Modal structure
 */
export class ModalBody extends Component<PropsWithChildren<IModalBody>, {}> {
  public state = {
    bodyMaxHeight: null,
  };
  // referense to a component
  private node: HTMLElement | null;

  public componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  public handleResize = () => {
    const { isFullScreen } = this.props;

    // fixed-positioned wrapper for modal-dialog
    const mWrapper = classAttr.findAncestor(this.node, 'modal');
    // dialog showed to a user
    const mDialog = classAttr.findAncestor(this.node, 'modal-dialog');

    // calculate available height for modal-body as (windowHeight - modalHeaderHeight - modalFooterHeight)
    if (mWrapper && mDialog) {
      const mHeader = mDialog.querySelector('.modal-content > .modal-header') as HTMLElement;

      const mFooter = mDialog.querySelector('.modal-content > .modal-footer') as HTMLElement;

      const modalSize = mWrapper.getBoundingClientRect();
      let maxHeight = Math.floor(modalSize.height);

      if (mHeader) {
        maxHeight -= mHeader.offsetHeight;
      }
      if (mFooter) {
        maxHeight -= mFooter.offsetHeight;
      }

      // if this is not full screen - respect dialog's top and bottom margin coming from Bootstrap styles
      if (!isFullScreen) {
        const style = getComputedStyle(mDialog);
        maxHeight -= style.marginTop ? parseFloat(style.marginTop) : 0;
        maxHeight -= style.marginBottom ? parseFloat(style.marginBottom) : 0;
      }

      this.setState({ bodyMaxHeight: maxHeight });
    }
  };

  public setNodeRef = (ref: HTMLElement | null) => {
    this.node = ref;
  };

  public render() {
    // NOTE: temporary do not set max height
    // TODO: return this code back once we fix dropdown, multiselect, datepickers
    /**
     * const style = this.state.bodyMaxHeight
     * ? { maxHeight: this.state.bodyMaxHeight + 'px', height: 'auto' }
     * : {};
     *
     * if (this.props.isFullScreen) {
     *   style.height = style.maxHeight;
     * }
     */
    const style = { height: 'auto' };

    if (this.props.isFullScreen) {
      style.height = this.state.bodyMaxHeight + 'px';
    }

    const modalBodyClasses = classNames('modal-body', this.props.className);

    return (
      <div className={modalBodyClasses} style={style} ref={this.setNodeRef}>
        {this.props.children}
      </div>
    );
  }
}

/**
 * We export ModalBody as it is to support Styleguist's patterns.
 * And we export enhanced component as default for the actual usage
 * @see {@link https://react-styleguidist.js.org/docs/thirdparties.html}
 */
export default withModalContext(ModalBody);
